export function NatureIllustration({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 400 500"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="sky" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#D7EEF0" />
          <stop offset="55%" stopColor="#EAF4F2" />
          <stop offset="100%" stopColor="#CFE6E6" />
        </linearGradient>
        <radialGradient id="sun" cx="50%" cy="50%">
          <stop offset="0%" stopColor="#F4DE86" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#ECD24E" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="water" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#9FD3D8" />
          <stop offset="100%" stopColor="#6BC4CE" />
        </linearGradient>
        <linearGradient id="stoneA" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#2BA7B3" />
          <stop offset="100%" stopColor="#0A8E9C" />
        </linearGradient>
        <linearGradient id="stoneB" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#F0DA8A" />
          <stop offset="100%" stopColor="#C8971F" />
        </linearGradient>
        <linearGradient id="stoneC" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#3FB0BB" />
          <stop offset="100%" stopColor="#119AA8" />
        </linearGradient>
        <linearGradient id="stoneD" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#7FCED6" />
          <stop offset="100%" stopColor="#4FB6C0" />
        </linearGradient>
      </defs>

      {/* Sky / background */}
      <rect width="400" height="500" fill="url(#sky)" />

      {/* Soft sun glow */}
      <circle cx="290" cy="120" r="120" fill="url(#sun)" />
      <circle cx="290" cy="120" r="34" fill="#F4DE86" opacity="0.55" />

      {/* Distant soft hills */}
      <path d="M 0 300 Q 110 258, 220 296 Q 320 330, 400 292 L 400 360 L 0 360 Z" fill="#BFE0DF" opacity="0.7" />
      <path d="M 0 320 Q 130 290, 250 318 Q 340 340, 400 318 L 400 360 L 0 360 Z" fill="#A9D6D6" opacity="0.7" />

      {/* Water surface */}
      <rect x="0" y="350" width="400" height="150" fill="url(#water)" />

      {/* Water ripples */}
      <g stroke="#FFFFFF" strokeOpacity="0.35" strokeWidth="1.5" fill="none" strokeLinecap="round">
        <path d="M 60 392 q 18 -6 36 0 t 36 0" />
        <path d="M 250 410 q 18 -6 36 0 t 36 0" />
        <path d="M 120 440 q 22 -7 44 0 t 44 0" />
        <path d="M 40 462 q 18 -6 36 0 t 36 0" />
      </g>

      {/* Balance stones — stacked cairn on the shore */}
      <g>
        {/* soft shadow on water */}
        <ellipse cx="200" cy="352" rx="78" ry="10" fill="#0A8E9C" opacity="0.18" />

        {/* bottom stone */}
        <ellipse cx="200" cy="338" rx="74" ry="26" fill="url(#stoneA)" />
        <ellipse cx="200" cy="332" rx="74" ry="22" fill="url(#stoneA)" />
        <path d="M 134 330 q 66 18 132 0" stroke="#06727E" strokeOpacity="0.35" strokeWidth="1.5" fill="none" />

        {/* second stone */}
        <ellipse cx="204" cy="296" rx="56" ry="22" fill="url(#stoneB)" />
        <ellipse cx="204" cy="290" rx="56" ry="18" fill="url(#stoneB)" />

        {/* third stone */}
        <ellipse cx="198" cy="258" rx="42" ry="18" fill="url(#stoneC)" />
        <ellipse cx="198" cy="253" rx="42" ry="15" fill="url(#stoneC)" />

        {/* top pebble */}
        <ellipse cx="201" cy="228" rx="26" ry="13" fill="url(#stoneD)" />
        <ellipse cx="201" cy="224" rx="26" ry="11" fill="url(#stoneD)" />
      </g>

      {/* Floating leaf */}
      <g opacity="0.9">
        <path
          d="M 96 196 Q 70 206, 60 232 Q 86 228, 100 210 Q 100 202, 96 196 Z"
          fill="url(#stoneC)"
        />
        <path d="M 96 196 Q 78 214, 62 230" stroke="#06727E" strokeWidth="1" fill="none" opacity="0.5" />
      </g>

      {/* Reed grasses bottom left */}
      <g stroke="#0A8E9C" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.55">
        <path d="M 44 500 Q 40 450, 52 416" />
        <path d="M 60 500 Q 60 452, 70 426" />
        <path d="M 76 500 Q 80 460, 90 436" />
      </g>

      {/* Gentle gold particles */}
      <circle cx="150" cy="150" r="2.5" fill="#ECD24E" opacity="0.7" />
      <circle cx="330" cy="220" r="2" fill="#ECD24E" opacity="0.6" />
      <circle cx="120" cy="100" r="1.8" fill="#ECD24E" opacity="0.5" />
      <circle cx="250" cy="180" r="1.6" fill="#ECD24E" opacity="0.5" />
    </svg>
  );
}
